import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'linkedinHandle'
})
export class LinkedinHandlePipe implements PipeTransform {


  private sanitizeLinkedIn(raw: string | null | undefined): string {
    if (!raw) return '';

    let val = raw.trim();

    // remove protocol
    val = val.replace(/^https?:\/\//i, '');

    // remove leading www.
    val = val.replace(/^www\./i, '');

    // try linkedin.com/in/<username>
    const matchIn = val.match(/linkedin\.com\/in\/([^\/\?\#]+)/i);
    if (matchIn && matchIn[1]) {
      val = matchIn[1];
    } else {
      // fallback: linkedin.com/<something>
      const matchGeneric = val.match(/linkedin\.com\/([^\/\?\#]+)/i);
      if (
        matchGeneric &&
        matchGeneric[1] &&
        !/^(in|company|school|pub)$/i.test(matchGeneric[1])
      ) {
        val = matchGeneric[1];
      }
    }

    // cut at first slash if still there
    val = val.split('/')[0];

    // strip query/hash
    val = val.split('?')[0].split('#')[0];

    // remove spaces
    val = val.replace(/\s+/g, '');

    return val;
  }

  transform(value: string | null | undefined): string {
    return this.sanitizeLinkedIn(value);
  }
}
